import { render, staticRenderFns } from "./BabyCompareTable.vue?vue&type=template&id=e64c3af0&scoped=true&"
import script from "./BabyCompareTable.vue?vue&type=script&lang=js&"
export * from "./BabyCompareTable.vue?vue&type=script&lang=js&"
import style0 from "./BabyCompareTable.vue?vue&type=style&index=0&id=e64c3af0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64c3af0",
  null
  
)

export default component.exports